import { render, staticRenderFns } from "./Pre_footer.vue?vue&type=template&id=43bb24b9&scoped=true&"
import script from "./Pre_footer.vue?vue&type=script&lang=ts&"
export * from "./Pre_footer.vue?vue&type=script&lang=ts&"
import style0 from "./Pre_footer.vue?vue&type=style&index=0&id=43bb24b9&prod&lang=css&"
import style1 from "./Pre_footer.vue?vue&type=style&index=1&id=43bb24b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb24b9",
  null
  
)

export default component.exports